import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

async function safeJson(res) {
    try {
        return await res.json();
    } catch (_) {
        return null;
    }
}

export const fetchCurrentOperator = async () => {
    const response = await apiFetch(`${API_BASE}/operators/operator`);

    const data = await safeJson(response);
    if (!response.ok) {
        const err = new Error((data && data.detail) ? data.detail : "Не вдалося завантажити дані оператора");
        err.status = response.status;
        err.data = data;
        throw err;
    }

    return data;
};